export const formatDate = date => {
  if (!date) {
    return '';
  }
  var dia = date.substring(8, 10);
  var mes = date.substring(5, 7);
  var anio = date.substring(0, 4);
  switch (mes) {
    case '01':
      mes = 'Ene';
      break;
    case '02':
      mes = 'Feb';
      break;
    case '03':
      mes = 'Mar';
      break;
    case '04':
      mes = 'Abr';
      break;
    case '05':
      mes = 'May';
      break;
    case '06':
      mes = 'Jun';
      break;
    case '07':
      mes = 'Jul';
      break;
    case '08':
      mes = 'Ago';
      break;
    case '09':
      mes = 'Sep';
      break;
    case '10':
      mes = 'Oct';
      break;
    case '11':
      mes = 'Nov';
      break;
    case '12':
      mes = 'Dic';
      break;
    default:
      break;
  }
  return dia + ' ' + mes + ' ' + anio;
};

export const formatDateOnlyNumbers = date => {
  const dateArray = splitDate(date);
  return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
};

const splitDate = dateString => {
  if (!dateString) return [];

  const parts = dateString.split('-');
  return parts;
};

export const formatDateTimeStamp = date => {
  const day = date[8] + date[9];
  const mounth = date[5] + date[6];
  const year = date[0] + date[1] + date[2] + date[3];
  const hour = date[11] + date[12];
  const minute = date[14] + date[15];

  const formattedDate =
    day + '-' + mounth + '-' + year + ' ' + hour + 'h' + ':' + minute + 'm';

  return formattedDate;
};

export function obtenerFechaFormateada(fechaStr) {
  // Crea un objeto Date a partir de la cadena de fecha
  const fecha = new Date(fechaStr);

  // Array de nombres de días de la semana en español
  const dias = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ];

  // Array de nombres de meses en español
  const meses = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  // Obtiene el nombre del día de la semana y el día del mes
  const diaSemana = dias[fecha.getDay()];
  const diaMes = fecha.getDate();

  // Obtiene el nombre del mes y el año
  const mes = meses[fecha.getMonth()];

  // Construye la cadena de salida con el formato "Día de la semana dia del mes de mes"
  const fechaFormateada = `${diaSemana} ${diaMes} de ${mes}`;

  // Devuelve la fecha formateada
  return fechaFormateada;
}

export function sumarUnDia(fecha) {
  // Incrementar la fecha en un día
  let fechaObjeto = new Date(fecha);
  fechaObjeto.setDate(fechaObjeto.getDate() + 1);

  // Obtener los componentes de la nueva fecha
  let nuevoDia = fechaObjeto.getDate();
  let nuevoMes = fechaObjeto.getMonth() + 1;
  let nuevoAnio = fechaObjeto.getFullYear();

  // Formatear la nueva fecha como "dd/mm/aaaa"
  let nuevaFecha =
    nuevoDia.toString().padStart(2, '0') +
    '/' +
    nuevoMes.toString().padStart(2, '0') +
    '/' +
    nuevoAnio.toString();

  return nuevaFecha;
}

export function calcularDiferenciaDias(fecha1, fecha2) {
  // Convierte las cadenas de fecha a objetos Date
  const date1 = new Date(fecha1);
  const date2 = new Date(fecha2);

  // Calcula la diferencia en milisegundos
  const diferenciaMilisegundos = date2 - date1;

  // Convierte la diferencia de milisegundos a días
  const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);

  return Math.abs(diferenciaDias); // Devuelve el valor absoluto en caso de fechas en orden inverso
}
